/** 气泡文案库：正能量，中英混合 */
export const POLO_QUOTES = [
  // 原有
  '我很酷',
  '我很潮',
  'Look Good ✨',
  '工装也要态度',
  'Comfort is King',
  '今日穿搭完成',
  '自信上班去',
  'Stay Sharp',
  '利落又精神',
  '这版型绝了',
  '企业关怀到位',
  '福利拉满 💼',
  '黑白都好搭',
  'Ready for Work',
  '在途范儿',
  'Pick Your Size',
  // 新增 30 句
  '今天也要元气满满',
  'Good Vibes Only',
  '穿出你的高光时刻',
  'You Got This 💪',
  '团队因你而闪亮',
  '每一件都是心意',
  'Shine On ✨',
  '自信是最好的搭配',
  '把工作过成诗',
  'Keep Going',
  '被看见的努力',
  '福利到心安',
  '今天状态满分',
  'New Day, New Energy',
  '同事夸我会穿',
  '舒适与体面兼得',
  '做自己的主角',
  'Stay Positive',
  '用心生活认真穿',
  '每一步都值得',
  '能量已加载完毕',
  '出发，去发光',
  '温暖的团队感',
  '细节里藏着温柔',
  '越穿越喜欢',
  '你的风格很好',
  "Let's Go!",
  '今日份好心情',
  '认真的人最好看',
  '一起向未来',
];

export function pickQuote(exclude) {
  const pool = exclude ? POLO_QUOTES.filter((q) => q !== exclude) : POLO_QUOTES;
  return pool[Math.floor(Math.random() * pool.length)];
}

/** 双只场景优先短句，避免两气泡挤在一起 */
export function pickShortQuote(exclude, maxLen = 9) {
  let pool = POLO_QUOTES.filter((q) => q.length <= maxLen);
  if (exclude) pool = pool.filter((q) => q !== exclude);
  if (!pool.length) return pickQuote(exclude);
  return pool[Math.floor(Math.random() * pool.length)];
}
